"use client";

import React from "react";
import { Link } from "@/components/common/Link";
const pillars = [{
  title: "Psychologische Praxis & Krisenberatung",
  description: "Seelische Gesundheit und Resilienz im Fokus.",
  color: "#7D5BA6",
  link: "https://praxis-soonwald.de",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_psychology.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_psychology.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_psychology.png-wvc-sizes"
  }
}, {
  title: "Organisationsberatung & Coaching",
  description: "Struktur und Klarheit für Teams und Führung.",
  color: "#4A6A8A",
  link: "https://christ-coaching.de",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_organization.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_organization.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_organization.png-wvc-sizes"
  }
}, {
  title: "Tai Chi Schule Soonwald",
  description: "Bewegung und Achtsamkeit in der Tradition.",
  color: "#C2B280",
  link: "https://tai-chi-soonwald.de",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_taichi.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_taichi.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_taichi.png-wvc-sizes"
  }
}, {
  title: "Wildnisschule Soonwald",
  description: "Naturverbindung und ursprüngliches Wissen.",
  color: "#76A344",
  link: "https://wildnisschule-soonwald.de",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_wilderness.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_wilderness.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/pillar_wilderness.png-wvc-sizes"
  }
}];
export default function Philosophyinterplay() {
  return;
}